module.exports = __webpack_public_path__ + "static/Tips-ae6385d2f2bd7c82801c3e68b81f0a96.png";